const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proc/privt2019/admin',
      name: 'proc_privt2019_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proc/privt2019/appl',
      name: 'proc_privt2019_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proc/privt2019/router.js